var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.darkMode ? 'dark' : 'light',attrs:{"id":"app"}},[_c('TopNotification',{attrs:{"message":"Hi, my web app is still under construction.","variant":!_vm.darkMode ? 'dark' : 'light'}}),_c('TheHeader',{attrs:{"no-shadow":""}}),_c('div',[_c('router-view')],1),_c('TheFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }